<template>
    <div class="as-app-car-list as-app-car-list-teaser">
        <div class="as-app-row">
            <div class="as-app-col as-app-col-12">
                <div v-if="$apollo.queries.carTeaser.loading">Lade Autos...</div>
                <div v-else class="as-app-slider-wrapper">
                    <div class="as-app-slider as-app-teaser-slider">
                        <div class="as-app-slider-item" v-for="car in carTeaserMerged" :key="car.id">
                            <a :href="$store.state.detailsPath+encodeURIComponent('-b-' + $R.pathOr('',['details','vehicle','classification','make','raw'], car) + '-' + $R.pathOr('',['details','vehicle','classification','make','formatted'], car) + '-m-' + $R.pathOr('',['details','vehicle','classification','model','formatted'], car).replace(/[^A-Za-z0-9]/g,'') + '-guid-' + car.id + '-offerid-' + $R.pathOr('',['details','identifier','offerReference'], car))" class="slider-item-inner">
                                <div class="relative-height ar-420-315 overflow-visible">
                                    <div class="relative-height-inner overflow-visible">
                                        <img v-if="typeof car.details.media.images[1] !== 'undefined' && car.details.media.images[1].__typename === 'StandardImage'"
                                             :src="car.details.media.images[0].formats.jpg.size800x600"
                                             class="as-app-car-image relative-height-image">
                                        <div v-if="car.id === $store.state.carOfTheWeekId" class="as-app-car-label as-app-car-of-the-week">Auto
                                            der Woche
                                        </div>

                                        <div v-else-if="((new Date() - new Date(car.details.publication.createdTimestampWithOffset)) / 86400000) < 14"
                                             class="as-app-car-label">Neu im Bestand
                                        </div>
                                    </div>
                                </div>
                                <div class="as-app-content-wrapper">
                                    <!--{{$R.pathOr('-',['id'], car)}}-->
                                    <h4 class="as-app-car-title">{{$R.pathOr('-',['details','adProduct','title'], car)}}</h4>
                                    <div class="as-app-upper-details-table">
                                        <span class="as-app-price">
                                              {{$R.pathOr('-',['details','prices','public','amountInEUR','formatted'], car)}}
                                        </span>
                                        <div class="as-app-price-rating au-widget-car-rating" data-enable-box-constraints data-layout="wide_without_price_with_explanation" data-theme="transparent" :data-car-url="$store.state.siteUrl+$store.state.detailsPath+encodeURIComponent('-b-' + $R.pathOr('',['details','vehicle','classification','make','raw'], car) + '-' + $R.pathOr('',['details','vehicle','classification','make','formatted'], car) + '-m-' + $R.pathOr('',['details','vehicle','classification','model','formatted'], car) + '-guid-' + car.id + '-offerid-' + $R.pathOr('',['details','identifier','offerReference'], car))"></div>
                                    </div>
                                    <div class="as-app-details-table">
                                        <div class="as-app-full-width">
                                            <span>
                                                {{$R.pathOr('-',['details','vehicle','fuels','primary','co2emissionInGramPerKm', 'formatted'], car)}},
                                                <template v-for="label in $R.pathOr([],['details','vehicle','environment','environmentLabels'], car)">
                                                    <template v-if="label.norm === 'EU_Directive_70_220_EEC_LDV'">{{label.label}}</template>
                                                </template>
                                            </span>
                                        </div>
                                        <div class="as-app-full-width">
                                            <span>
                                                {{_.round( $R.pathOr('-',['details','vehicle','fuels','primary','consumption','combined','raw'], car), 1)}}l/100km (komb),
                                                {{_.round( $R.pathOr('-',['details','vehicle','fuels','primary','consumption','urban','raw'], car), 1)}}l/100km (innerorts),
                                                {{_.round( $R.pathOr('-',['details','vehicle','fuels','primary','consumption','extraUrban','raw'], car), 1)}}l/100km (außerorts)
                                            </span>
                                        </div>
                                        <div><span>{{$R.pathOr('-',['details','vehicle','condition','mileageInKm','formatted'], car)}}</span></div>
                                        <div>
                                            <span>{{$R.pathOr('-',['details','vehicle','condition','firstRegistrationDate','formatted'], car)}}</span>
                                        </div>
                                        <div><span>{{$R.pathOr('-',['details','vehicle','engine','power','kw','formatted'], car)}} ({{$R.pathOr('-',['details','vehicle','engine','power','hp','formatted'], car)}})</span>
                                        </div>
                                        <div><span>{{$R.pathOr('-',['details','vehicle','fuels','primary','source'], car)}}</span></div>
                                        <div><span>{{$R.pathOr('-',['details','vehicle','condition','numberOfPreviousOwnersExtended','formatted'], car)}}</span>
                                        </div>
                                        <div><span>{{$R.pathOr('-',['details','vehicle','legalCategories','0','formatted'], car)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /*global auWidgetEmbed, auWidgetConfig, window */
    import Vue from 'vue'
    export default {
        name: 'CarTeaser',
        props: {
            msg: String
        },
        data() {
            return {
                withVehicleDetails: true,
                carTeaser: '',
                count: 4 //One as backup if
            }
        },
        computed: {
            carTeaserMerged() {
                if (this.carTeaser === '') return []
                // console.log('CarTeaser', this.carTeaser);
                let carsNew = this.carTeaser.listings.listings
                let cars = []
                if (typeof this.carTeaser.listing.details === 'object' && this.carTeaser.listing.details !== null && this.carTeaser.listing.details.publication.state === 'Active') {
                    let carOfTheWeek = {
                        id: this.carTeaser.listing.details.identifier.id,
                        details: this.carTeaser.listing.details
                    }
                    cars.push(carOfTheWeek)
                }
                let i = 0;
                let length = carsNew.length;
                for (i; i < length; i++) {
                    if(this.$store.state.carOfTheWeekId === carsNew[i].id) continue;
                    cars.push(carsNew[i])
                    if (cars.length === 4) break //Break if four cars have been pushed to the list.
                }

                // Filter images
                let e = 0;
                for (e; e < 4; e++){
                    cars[e].details.media.images = cars[e].details.media.images.filter(Vue.filterImages)
                }
                return cars
            }
        },
        mounted: function () {
            window.auWidgetConfig = {sourceName: 'Autohäuser Pohlheim'}
            let s=document.createElement('script')
            s.async=true
            s.src='//www.autouncle.de/widgets/embed.js?source_name='+encodeURIComponent(auWidgetConfig.sourceName)
            s.setAttribute('data-source-name',auWidgetConfig.sourceName)
            s.id='au-widget-script'
            let h=document.getElementsByTagName('head')[0]
            h.insertBefore(s,h.lastChild)
        },
        apollo: {
            carTeaser: {
                query: require('../graphql/CarTeaser.gql'),
                errorPolicy: 'all',
                variables() {
                    // Use vue reactive properties here
                    return {
                        guid: this.$store.state.carOfTheWeekId,
                        withVehicleDetails: true,
                        count: this.count, //Querying four cars even if three could be enough as one is already queried as car of the week. But as backup if the manualy selected car of the week is not present anymore selecting four without filters.
                        alias: 'carTeaser'
                    }
                },
                error(error) {
                    console.log('Car of the week might not be available anymore.')
                    // console.log({error})
                    if(error.networkError !== null && parseInt(error.networkError.statusCode) === 429){
                        Vue.logApiLimitReached();
                    }
                },
                result(data) {
                    if (typeof data.error === 'undefined' && typeof data.data !== 'undefined' && !data.loading) {
                        // console.log(data);
                        // let self = this

                        data.data.carTeaser.listings.listings = Vue.filterImagesInResultsArray(data.data.carTeaser.listings.listings);

                        this.$nextTick(() => {
                            if(typeof auWidgetEmbed !== 'undefined' && typeof auWidgetEmbed.init !== 'undefined'){
                                auWidgetEmbed.init()
                            }
                        })
                    }
                }
            }

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../styles/style";

    @import "../styles/partials/_car-list";
    @import "../styles/partials/_car-list-teaser";
</style>
